//ts-check
import {DragDropProvider} from '@dnd-kit/react'
import {Skeleton} from '@mui/material'
import {Font} from 'pepsico-ds'
import {BrandItem} from './BrandItem'

/**
 * @param {{
 *   brands: import('@/types/productCatalogTypes').ProductCategoryBrand[],
 *   setBrands: import('react').Dispatch<import('react').SetStateAction<import('@/types/productCatalogTypes').ProductCategoryBrand[]>>,
 *   isLoading: boolean,
 *   onDragEnd: (event: import('@dnd-kit/dom').DragEndEvent) => void,
 * }} props
 */
export const BrandsSection = ({brands, setBrands, isLoading, onDragEnd}) => {
  return (
    <div className="borde flex flex-col gap-6 rounded-lg bg-gray-850 p-6">
      <div className="flex items-center justify-between">
        <Font variant="bold">Brands</Font>
      </div>
      {isLoading ? (
        <div className="flex gap-8 overflow-x-auto">
          {Array.from({length: 6}, (_, i) => (
            <Skeleton key={i} variant="rectangular" className="min-w-[230px] rounded-lg" width={230} height={160} />
          ))}
        </div>
      ) : (
        <DragDropProvider onDragEnd={onDragEnd}>
          <div className="flex gap-8 overflow-x-auto">
            {brands.map((brand, index) => (
              <BrandItem key={brand.id} brand={brand} position={index + 1} setBrands={setBrands} />
            ))}
          </div>
        </DragDropProvider>
      )}
    </div>
  )
}
